import {
  FAQ_SETTINGS_START_EDIT,
  FAQ_SETTINGS_SET_FIELD,
  FAQ_SETTINGS_CANCEL_EDIT,
  FAQ_SETTINGS_FINISH_EDIT,
} from 'constants/action_names';

const initialState = {
  faq: null,
  valid: true,
  validationMessages: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FAQ_SETTINGS_START_EDIT:
      return {
        ...state,
        faq: action.faq,
        valid: true,
        validationMessages: [],
      };
    case FAQ_SETTINGS_SET_FIELD:
      return {
        ...state,
        faq: {
          ...state.faq,
          [action.field]: action.value,
        },
      };
    case FAQ_SETTINGS_CANCEL_EDIT:
      return { ...initialState };
    case FAQ_SETTINGS_FINISH_EDIT:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;
